import React from 'react'

function TurboPaymentRequestFill() {
  return (
    <div className='distributorList m-4'>
        <div className='row m-4'>
        <div class="card p-2 mb-3 rounded"><div class="text-danger"><p class="mb-1"><strong>Pay Attention:</strong> Amount will be credited to your wallet by the tomorrow at 11am.</p></div></div>
        </div>
    </div>
  )
}

export default TurboPaymentRequestFill